import { Notifications } from '.'
import { IFI } from '../../CIMSModule/instances'
import { CIMSPageItem } from '../CIMSPageItem'

export const IFITracker = new CIMSPageItem({
  module: IFI,
  id: 'c3994c01-1605-413b-80dd-c91356aa2c70',
  name: 'IFI Tracker',
  pathname: 'tracker',
  linkable: true,
})
export const IFINotifications = Notifications({
  id: 'ac18a365-6cc0-4115-b602-61ddf2049080',
  module: IFI,
})
export type IFIPageItem = typeof IFITracker | typeof IFINotifications
